module.exports = __webpack_public_path__ + "img/download_xml.86f552a8.svg";